import { isPoint } from './is-point.js';
var isPoint3D = function isPoint3D(point) {
  return isPoint(point) && point.hasOwnProperty('z');
};
export { isPoint3D };